<template>
  <div class="info-box">
    <div class="flex-1 overflow-y-auto gap-x-3">
      <el-form
        :model="state.model"
        label-width="auto"
        label-position="top"
        ref="formDom"
        size="large"
        class="overflow-y-auto px-2.5"
      >
        <el-form-item label="状态">
          <el-switch
            v-model="state.model.status"
            active-text="启用"
            inactive-text="禁用"
            inline-prompt
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
        <el-form-item
          label="名称"
          prop="name"
          :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item
          label="规格"
          prop="specification"
          :rules="[{ required: true, message: '请输入规格', trigger: 'blur' }]"
        >
          <el-input v-model="state.model.specification"></el-input>
        </el-form-item>
        <ul class="grid grid-cols-2 gap-x-5">
          <el-form-item
            label="类型"
            prop="d_cost_type_pid"
            :rules="[
              { required: true, message: '请选择类型', trigger: 'blur' },
            ]"
          >
            <el-tree-select
              v-model="state.model.d_cost_type_id"
              :data="state.lx_data"
              node-key="id"
              :props="{
                children: 'children',
                label: 'name',
              }"
              :expand-on-click-node="false"
              clearable
              default-expand-all
              @current-change="onLxChange"
            >
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadTree"
                >
                  刷新
                </el-button>
              </template>
            </el-tree-select>
          </el-form-item>
          <el-form-item
            label="单位"
            prop="d_measure_unit_id"
            :rules="[
              { required: true, message: '请输入联系人', trigger: 'blur' },
            ]"
          >
            <el-select v-model="state.model.d_measure_unit_id">
              <el-option
                v-for="item in state.dw_data"
                :key="item"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadDw"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
        </ul>
        <el-form-item label="备注">
          <el-input v-model="state.model.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="submit-box px-2.5">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { dic_getCostType, dic_getMeasureUnit } from "@/http/data";
import { costitem_detail, costitem_add, costitem_edit } from "@/http/costitem";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: { status: 1 },
    });
    onMounted(() => {
      onLoadLx();
      onLoadDw();

      if (props.id) {
        costitem_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data?.data || {};
          }
        });
      }
    });

    //获取类型
    const onLoadLx = () => {
      dic_getCostType({ tree: 1 }).then((res) => {
        if (res.status == 200) {
          const { data } = res.data;

          let lx_data = [];
          data.forEach((e) => {
            if (!e.children || e.children.length <= 0) e.disabled = true;
            lx_data.push(e);
          });
          state.lx_data = lx_data;
        }
      });
    };

    const onLxChange = (e) => {
      state.model.d_cost_type_pid = e.pid;
    };

    //获取单位
    const onLoadDw = () => {
      dic_getMeasureUnit().then((res) => {
        if (res.status == 200) {
          state.dw_data = res.data?.data || [];
        }
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            costitem_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            costitem_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onLoadLx,
      onLoadDw,
      onSubmit,
      onLxChange,
    };
  },
};
</script>
<style scoped></style>
